document.addEventListener('DOMContentLoaded', () => {
  const link = document.querySelector('a.cmplz-manage-cookie');
  console.log('Complianz link found:', link);

  if (!link) {
    return;
  }

  link.addEventListener('click', (e) => {
    e.preventDefault();

    const consents = document.querySelectorAll('.cmplz-manage-consent');
    if (consents.length) {
      consents.forEach((el) => {
          el.click();
      });
    } else {
      console.warn('Complianz object or open function not found.');
    }

    return false;
  });
});
